import config from "@/common/config.js";
import ajax from "../../plugins/ajax";
import { cloneDeep } from "lodash";

// 产品信息，用于单条新建
const state = {
  productInfo: {},
  images: [], // 主图
  mainVideo: {}, // 主图视频
  detailVideo: {}, // 详情视频
  offerCount: null, // 左侧栏菜单对应产品数量
  addressList: [], // 发货地址
  templateList: [], // 旧的运费模板 包含所有模板
  newTemplateList: [], // 新的运费模板 不含type==3的
  guideTemplate: {}, // 运费指导模板
  freightOptions: [
    // 运费设置
    { label: "使用运费模板", value: null, key: "T" },
    { label: "运费指导模板", value: 0, key: "D" },
    { label: "卖家承担运费", value: 1, key: "F" },
  ],
};

const getters = {};

const mutations = {
  setProductInfo(state, data) {
    if (!data.Attributes) {
      data.Attributes = [];
    }
    if (!data.SkuInfos) {
      data.SkuInfos = [];
    }
    if (!data.SaleInfo) {
      data.SaleInfo = {};
    }
    if (!data.ShippingInfo) {
      data.ShippingInfo = {};
    }
    if (!data.ProductId) {
      data.ProductId = undefined;
    }

    state.productInfo = data;
    state.images = (data.Image?.images ?? [])
      .slice(0, 5)
      .map((img) => img.replace(config.alicdn, ""));
  },
  setProductInfoByKey(state, { key, val }) {
    state.productInfo[key] = val;
  },
  clearProductInfo() {
    state.productInfo = {};
  },
  cleanSupplyInfo(state) {
    state.productInfo = {};
    state.images = [];
    state.mainVideo = {};
    state.detailVideo = {};
  },
  updateImages(state, data) {
    state.images = data;
  },
  updateImagesByIndex(state, { index, url }) {
    state.images.splice(index, 1, url);
  },
  spliceImages(state, index) {
    state.images.splice(index, 1);
  },
  setVideo(state, { mainVideo, detailVideo }) {
    if (mainVideo) {
      state.mainVideo = mainVideo;
    }
    if (detailVideo) {
      state.detailVideo = detailVideo;
    }
  },
  syncVideo(state) {
    if (state.mainVideo.videoUrl) {
      state.detailVideo = cloneDeep(state.mainVideo);
    }
  },
  setOfferCount(state, data) {
    state.offerCount = data || {};
  },
  setAddressList(state, data) {
    const oldData = cloneDeep(state.addressList);
    let oldTypes = {};
    oldData.forEach((v) => {
      if (v?.Type) {
        oldTypes[v.Id] = v.Type;
      }
    });
    state.addressList = data.map((item) => {
      if (oldTypes[item.Id]) {
        item.Type = oldTypes[item.Id];
      }
      return item;
    });
    oldTypes = null;
  },
  setTemplateList(state, data) {
    state.templateList = data;
    state.newTemplateList = data.filter((v) => {
      return v.Type !== "3";
    });
  },
  setGuideTemplateList(state, res) {
    const data = cloneDeep(state.guideTemplate);
    data[res.addressId] = res.data;
    state.guideTemplate = data;
  },
  asyncAddressList(state, data) {
    // eslint-disable-next-line array-callback-return
    const index = state.addressList.findIndex((v) => {
      if (data[v.Id]) {
        return true;
      }
    });
    const item = cloneDeep(state.addressList[index]);
    item.Type = data[item.Id];
    state.addressList.splice(index, 1, item);
  },
};

const actions = {
  setProductInfoAsync({ commit }, data) {
    commit("setProductInfo", data);
  },
  setOfferCountAsync({ commit }) {
    ajax.post("app/api/offer/getoffercount").then((res) => {
      commit("setOfferCount", res.Data);
    });
  },
  setAddressListAsync({ commit }, callback) {
    ajax.post("app/ali/sendgoodsAddressesv2").then((res) => {
      commit(
        "setAddressList",
        (res.Data || []).map((address) => {
          address.FullAddress = address.FullAddress.replace(/\^\^\^/g, ">");
          return address;
        })
      );
      callback && callback();
    });
  },
  setGuideTemplateListAsync({ commit, state }, { addressId, callBack, needRequst }) {
    // 请求运费指导模板
    if (state.guideTemplate[addressId] && !needRequst) {
      // 有缓存
      commit("setGuideTemplateList", { addressId, data: state.guideTemplate[addressId] || [] });
      callBack && callBack();
    } else {
      ajax.post("app/ali/freighttemplatesv2", { addressId }).then((res) => {
        commit("setGuideTemplateList", {
          addressId,
          data:
            res.Data.filter((v) => {
              return v.Type === "3";
            }) || [],
        });
        callBack && callBack();
      });
    }
  },
  setTemplateListAsync({ commit }, callback) {
    ajax.post("app/ali/freighttemplatesv2").then((res) => {
      commit("setTemplateList", res.Data || []);
      callback && callback();
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
